module.exports = __webpack_public_path__ + "img/Notibell.649c1b7f.svg";